/**
 * ExitFullscreenIcon - Icon representing exit fullscreen/contract action
 * Feature: 081-photo-versioning
 *
 * Standard exit fullscreen icon with four corner arrows pointing inward
 */

import type { IconProps } from './IconTypes';

export function ExitFullscreenIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'Exit fullscreen',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {/* Four corner arrows pointing inward */}
      <path d="M8 3v4a1 1 0 01-1 1H3m18 0h-4a1 1 0 01-1-1V3m0 18v-4a1 1 0 011-1h4M3 16h4a1 1 0 011 1v4" />
    </svg>
  );
}
